import { Message, MessageType } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';

export const ReceptionServiceAdvancePaymentWarning = (): JSX.Element | null => {
   return (
      <Message
         testId={'receptionServiceAdvancePaymentSmsWarning'}
         type={MessageType.WARNING}
         displayIndicator
         label={receptionServiceTranslationKeys.shared.form.components.advancePaymentWarning}
      />
   );
};
